export const catalogCenterEn = {
  businessCategory: "Business Entry",
  platformEntryCategory: "Platform Entry",
  platformCenterCategory: "Platform Center",
  platformCapabilityCategory: "Platform Capability",
  platformInfrastructureCategory: "Platform Infrastructure",
  examAdminName: "Exam Admin",
  examAdminNote: "Questions, papers, exams, review, and exam staff operations.",
  candidateName: "Candidate App",
  candidateNote: "Exam entry, answers, submission, and result queries.",
  microLabName: "Micro Lab",
  microLabNote: "Micro-lab plaza and experiment run entry connected directly to unified identity, asset center, and execution fabric.",
  eduAdminName: "Edu Admin",
  eduAdminNote: "Courses, teaching plans, training projects, members, and public-course governance.",
  eduName: "Edu Learning",
  eduNote: "Public learning, assigned study, training projects, and learner entry.",
  aitestName: "Test Range",
  aitestNote: "Minimal platform integration validation app connected directly to unified identity, asset center, and execution fabric.",
  redblueAdminName: "RedBlue Admin",
  redblueAdminNote: "Admin workspace for red-blue exercise schemes, activities, director console, judge console, and situation review.",
  redblueName: "RedBlue Portal",
  redblueNote: "Participant portal for red-blue exercises, workbench, observation, and reports.",
  portalName: "AIRange Portal",
  portalNote: "Unified portal, application navigation, and primary entry.",
  resourceSpace: "Resource Space",
  resourceSpaceNote: "Enter personal and shared resource spaces to manage uploaded files, brand assets, and shared materials.",
  accountCenter: "Account Center",
  accountCenterNote: "Account information and personal settings entry for unified identity users.",
  platformAdminName: "Platform Admin",
  platformAdminNote: "Platform control plane admin; does not carry exam business pages.",
  ssoName: "Unified Identity Center",
  ssoNote: "Unified login, sessions, application onboarding, and identity policies.",
  assetsName: "Asset Center",
  assetsNote: "Object storage, metadata, and authorization controls.",
  environmentNote: "Manage environment specs, images, templates, and topology assets in one place.",
  executionName: "Execution Fabric",
  executionNote: "Container runtime, instance orchestration, and execution control plane.",
  taskCenterName: "Task Center",
  taskCenterNote: "Task state semantics, event observability, and failure-code governance.",
  instanceCenterNote: "Review instance runtime state, remote sessions, and instance-level operations in one place.",
  orchestratorCenterNote: "Review orchestration requests, recycle flows, and orchestration actions in one place.",
  intelligenceCenterNote: "Manage model connections, provider configs, task runs, and audit logs in one place.",
  capabilityGraphNote: "Explore the capability graph, KSA categories, and capability relationships in one place.",
  tacticsTechniquesHubNote: "Review tactics-techniques frameworks, matrix mappings, and binding playgrounds in one place.",
  vulnerabilityLibraryNote: "Unified CVE, CNVD, official vulnerability identifiers, and internal vulnerability records.",
  businessReferenceCenterNote: "Register cross-business resource references, reverse lookup relations, and pre-change protection checks.",
  trafficLibraryNote: "Register packet files, one-level categories, and Asset Center file references.",
  toolsLibraryNote: "Manage system-hosted tool files, one-level categories, and download entry points.",
  examApiName: "Exam API",
  examApiNote: "Dedicated public exam API resolved from the service endpoint registry.",
  registryNote: "Review platform registry integration and availability in one place.",
} as const;
